import React, { useState } from 'react';
import companyLogo from "./images/ladradoc.png";
import LoginCliente from './api/loginCliente';
import {
  MDBContainer,
  MDBBtn,
  MDBIcon,
  MDBInput
} from 'mdb-react-ui-kit';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // --- LÓGICA LOGIN TRADICIONAL ---
  // const handleLocalLogin = async (e) => {
  //   e.preventDefault();
  //   if (!email || !password) {
  //     alert("Por favor, completa todos los campos.");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const response = await LoginCliente(email, password);
      
  //     if (response.auth) {
  //       localStorage.setItem('user', JSON.stringify(response.user));
  //       // Redirección según tipo de usuario
  //       if (response.user.tipo === 'a') {
  //         window.location.href = '/#/agendaAdmin';
  //       } else {
  //         window.location.href = '/#/agenda';
  //       }
  //     } else {
  //       alert(response.msg || "Error al iniciar sesión");
  //     }
  //   } catch (error) {
  //     alert("Error de conexión con el servidor local.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleLocalLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      alert("Por favor, completa todos los campos.");
      return;
    }

    setLoading(true);
    try {
      const response = await LoginCliente(email, password);
      
      if (response.auth) {
        // 1. Guardamos los datos
        localStorage.setItem('user', JSON.stringify(response.user));
        
        // Convertimos a String explícitamente para evitar problemas de tipos en el storage
        localStorage.setItem('mustChangePassword', String(response.mustChangePassword));

        // 2. IMPORTANTE: Usamos window.location.hash directamente para HashRouter
        // Y agregamos un minúsculo delay para asegurar que el storage se guardó
        setTimeout(() => {
          if (response.mustChangePassword === true || response.mustChangePassword === "true") {
            window.location.hash = '/reset-password';
          } else {
            // Verificamos 'Tipo' (Mayúscula) que es como suele venir del backend
            const tipo = response.user.Tipo || response.user.tipo;
            if (tipo === 'a') {
              window.location.hash = '/agendaAdmin';
            } else {
              window.location.hash = '/agenda';
            }
          }
        }, 100);

      } else {
        alert(response.msg || "Error al iniciar sesión");
      }
    } catch (error) {
      console.error("Login Error:", error);
      alert("Error de conexión con el servidor local.");
    } finally {
      setLoading(false);
    }
  };

  // --- LÓGICA GOOGLE ---
  const handleGoogleLogin = () => {
    const baseUrl = window.location.hostname === 'localhost' 
      ? 'http://localhost:4000' 
      : 'https://vetladradoc.uy';
    window.location.href = `${baseUrl}/api/auth/google`;
  };

  return (
    <MDBContainer 
      style={{ maxWidth: "400px", minHeight: "100vh" }} 
      className="px-4 py-5 d-flex flex-column w-100 text-center justify-content-center"
    >
      <div className='div-foto mb-4'>
        <img 
          className="foto-padding foto-size" 
          src={companyLogo} 
          alt="Ladradoc Logo" 
          style={{ maxWidth: '50%', height: 'auto' }} 
        />
      </div>

      <h4 className="mb-4 text-dark">Bienvenido a Ladradoc</h4>

      {/* Campos de Email y Password */}
      <MDBInput 
        wrapperClass='mb-3' // Reducimos un poco el margen inferior
        label='Correo Electrónico' 
        type='email' 
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <MDBInput 
        wrapperClass='mb-4' 
        label='Contraseña' 
        type='password' 
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      {/* Botón de Login Tradicional con altura fija */}
      <MDBBtn 
  className="w-100 mb-2 p-0" 
  style={{ 
    backgroundColor: '#2b2b2b', 
    height: '48px',
    fontSize: '16px',
    fontWeight: '600',
    textTransform: 'none',
    position: 'relative', // Base para el posicionamiento interno
    overflow: 'hidden',
    border: 'none',
    boxShadow: 'none'
  }}
  onClick={handleLocalLogin}
  disabled={loading}
>
  {/* Este div ignora los paddings de MDB y se clava en el centro exacto */}
  <div style={{ 
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    textAlign: 'center',
    pointerEvents: 'none' // Para que el click pase a través del div al botón
  }}>
    {loading ? 'Cargando...' : 'Iniciar Sesión'}
  </div>
</MDBBtn>

      <div className="d-flex align-items-center my-3">
        <hr className="flex-grow-1" />
        <span className="mx-2 text-muted small">O</span>
        <hr className="flex-grow-1" />
      </div>

      {/* Botón de Google */}
      <MDBBtn 
        size="lg" 
        style={{ 
          backgroundColor: '#dd4b39', 
          color: 'white',
          height: '48px'
        }} 
        onClick={handleGoogleLogin}
        className="w-100 p-0"
      >
        <div className="d-flex align-items-center justify-content-center w-100 h-100">
          <MDBIcon fab icon='google' className='me-2'/> 
          <span style={{ fontWeight: '500' }}>Continuar con Google</span>
        </div>
      </MDBBtn>

      <div className="text-center mt-4">
        <p className="small text-muted">
          ¿No tienes cuenta? <a href="/#/register" className="text-primary">Regístrate aquí</a>
        </p>
      </div>

    </MDBContainer>
  );
}

export default Login;